<template>
  <div class="home-image-wrap left">
    <div class="tta-vid image">
        <video id="ttavid" src="../assets/vid/tta-vid2.mp4" autoplay muted loop></video>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    playVid: function() {
      this.document.getElementById('ttavid').play();
    }
  }
};
</script>

<style lang="scss" scoped>
.home-image-wrap {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  position: relative;
  height: 100%;
  width: 100%;
  svg {
      position: absolute;
      top:25px;
      left:25px;
      width:300px;
      height:auto;
      fill:#fff;
      z-index:9;
  }
  .image {
    position: absolute;
    top: 0;
    left: 0;
    background-position: center;
    background-size: auto;
    width: 100%;
    height: 100%;
  }
  .tta-vid {
    max-width:100%;
    max-height:100%;
    height:100%;
    overflow:hidden;
    z-index: 8;
    animation: fadeDown 0.8s ease .5s both 1;
    video {
        width:100%;
        height:100%;
    }
  }
}

.home.page.page-trans-leave-active {
  .page-wrap {
    .home-hero {
      .home-image-wrap {
        .tts-vid {
          animation: leaveQuick 0.1s ease 0.2s both 1;
        }
      }
    }
  }
}

@keyframes fadeDown {
  from {
    transform: translateY(-40px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes leaveQuick {
  from {
    transform: translateX(0%);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
}
</style>

